function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "bus"
}, /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M27.61,12H27V4.53A2.54,2.54,0,0,0,24.47,2H7.53A2.54,2.54,0,0,0,5,4.53V12H4.39A2.39,2.39,0,0,0,2,14.39V17a1,1,0,0,0,1,1H6a1,1,0,0,0,1-1H25v3H22a2.07,2.07,0,0,0-2,2.16V24H12V22.16A2.07,2.07,0,0,0,10,20H6a1,1,0,0,0-1,1v2.47A2.54,2.54,0,0,0,7.53,26H8v1a3,3,0,0,0,6,0V26h4v1a3,3,0,0,0,6,0V26h.47A2.54,2.54,0,0,0,27,23.47V18h2a1,1,0,0,0,1-1V14.39A2.39,2.39,0,0,0,27.61,12ZM4,14.39A.4.4,0,0,1,4.39,14H5v2H4ZM18,15v-.5a1.5,1.5,0,0,1,3,0V15Zm5,0v-.5a3.5,3.5,0,0,0-7,0V15H7V7H22a1,1,0,0,0,0-2H7V4.53A.53.53,0,0,1,7.53,4H24.47a.53.53,0,0,1,.53.53V15ZM7,23.47V22l2.94,0a.25.25,0,0,1,.06.19V24H7.53A.53.53,0,0,1,7,23.47ZM12,27a1,1,0,0,1-2,0V26h2Zm10,0a1,1,0,0,1-2,0V26h2Zm2.47-3H22V22.16c0-.09,0-.15,0-.16h3v1.47A.53.53,0,0,1,24.47,24ZM28,16H27V14h.61a.4.4,0,0,1,.39.39Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M14,20h4a1,1,0,0,0,0-2H14a1,1,0,0,0,0,2Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M14,23h4a1,1,0,0,0,0-2H14a1,1,0,0,0,0,2Z"
}));

var SvgBus = function SvgBus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bus.cd13b938.svg";
export { ForwardRef as ReactComponent };